import React from 'react';

import I18n from 'utils/I18n';
import { csrfToken } from 'utils/networking-client';

import { useCheckoutContext } from '../../../state/CheckoutContext';

import styles from './PayPalCheckout.scss';

// Note:
// After POSTing the form, we redirect the athlete to PayPal's URI where
// they enter their PayPal info. PayPal then redirects them back to our app.
// Because this legacy PayPal flow and the SummitPayPalController use plain
// old redirects, we can use a plain old HTML form to POST without any need
// for redux or component instance methods.

const PayPalCheckout = () => {
  const { checkoutEntityState } = useCheckoutContext();

  const { duration, products } = checkoutEntityState;
  const sku = products?.[duration]?.sku;
  const promotionCode = products?.promotion?.code;

  return (
    <form action="/paypal/summit_checkout" method="post">
      <input
        className={styles.logo}
        type="image"
        src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/checkout-logo-large.png"
        alt={I18n.t('strava.subscriptions.checkout.form.paypal')}
      />
      <input type="hidden" name="sku" value={sku} />
      <input type="hidden" name="duration" value={duration} />
      <input type="hidden" name="authenticity_token" value={csrfToken()} />
      {promotionCode && (
        <input type="hidden" name="code" value={promotionCode} />
      )}
    </form>
  );
};

export default PayPalCheckout;
